(function () {
  

  $("#submit-btn").click(function () {
    submitUpdate();
  });
  
  function submitUpdate() {
    const customerId = $('#customer').data('id');
    const firstName = $('#firstName').val();
    const lastName = $('#lastName').val();
    const email = $('#email').val();
    const phone = $('#phone').val();
    const acceptsMarketing = $('#acceptsMarketing').prop('checked');
    const marketingState = acceptsMarketing ? 'SUBSCRIBED' : 'UNSUBSCRIBED';

    $.ajax({
      url: 'https://mopio-shopify.castlery.com/customer',
      method: 'post',
      headers: {
        "Content-Type": "application/json",
      },
      dataType: "json",
      data: JSON.stringify({
        "type": "mutation",
        "module": "customer:basicinfos",
        "customerId": customerId,
        "payload": {
          "firstName": firstName,
          "lastName": lastName,
          "email": email,
          "phone": phone,
          "emailMarketingConsent": {
            "marketingState": marketingState
          }
        }
      }),
      success: function (response) {
        if (response.code === 0) {
          alert('Update success!');
          location.replace('/account');
        } else {
          alert(`Update failed: ${response.message}`);
        }
      },
      error: function (error) {
        const errorMessage = error.responseJSON.message;
        const trimmedErrorMessage = errorMessage.trim();
        alert(`Update failed: ${trimmedErrorMessage}`);
      }
    });


  }

})();